import getFp from 'lodash/fp/get';

export const rootSelector = getFp('conceptCanvas');
